// The documents a rep can send from a client's E-Sign tab, and who may send which.
//
// WS #2228909. After a card declines, a PACK rep (role affiliate) takes another card and sends a Payment
// Change Addendum for it. Affiliates get the PCA only; the server limits them to their office's clients
// (POST /sign-template, bodyContactAccessGuard).
export const ESIGN_TEMPLATES = [
  { id: 'pca', form_name: 'PAYMENT CHANGE ADDENDUM', description: "Template 1" },
  { id: 'legalServiceAgreement', form_name: 'LEGAL SERVICES AGREEMENT', description: "Template 2" },
  { id: 'legalServiceAgreementSpanish', form_name: 'LEGAL SERVICES AGREEMENT (BILINGUAL)', description: "Template 3" },
  { id: 'revoked-poa', form_name: 'REVOKED POWER OF ATTORNEY', description: "Template 4" },
  { id: 'poa', form_name: 'POWER OF ATTORNEY', description: "Template 4" },
]

const AFFILIATE_TEMPLATES = ['pca']

export const esignTemplatesFor = (userRole) => (userRole === 'affiliate'
  ? ESIGN_TEMPLATES.filter((row) => AFFILIATE_TEMPLATES.includes(row.id))
  : ESIGN_TEMPLATES)

// The popup that collects a document's fields before it is previewed and sent. Affiliates only with
// PCA_FOR_AFFILIATES on.
export const canOpenTemplatePopup = ({ userRole, isSupervisor, typeDoc, pcaForAffiliates = false }) =>
  userRole === 'customer' || !!isSupervisor
  || (pcaForAffiliates && userRole === 'affiliate' && AFFILIATE_TEMPLATES.includes(typeDoc))

export const AGREEMENT_TEMPLATES = ['legalServiceAgreement', 'legalServiceAgreementSpanish']

export const ESIGN_ROLE_MESSAGE = 'Only an admin or a supervisor can send e-sign documents.'

export const ESIGN_ROLE_POINTER = 'To send the client their signing link, use Signing link above.'

export const AGREEMENT_NEEDS_ACCOUNT = 'The agreement needs a bank account or card on file to be prepared here. For a lead who has not signed yet, use Signing link at the top of the Docs tab: the client adds a payment method there and signs.'
